// ===== STATE =====
let currentStep = 0;
const TOTAL_STEPS = 9;
let breakdownOpen = false;
let currentPattern = 'overlap';
let isAnimating = false;

// ===== PROGRESS DOTS =====
(function() {
  const wrap = document.getElementById('hdr-dots');
  for (let i = 0; i < TOTAL_STEPS; i++) {
    const d = document.createElement('div');
    d.className = 'hdr-dot' + (i === 0 ? ' active' : '');
    d.id = 'dot-' + i;
    wrap.appendChild(d);
  }
  updateHdrStep(0);
})();

function updateDots(step) {
  for (let i = 0; i < TOTAL_STEPS; i++) {
    const d = document.getElementById('dot-' + i);
    d.className = 'hdr-dot' + (i < step ? ' done' : i === step ? ' active' : '');
  }
  updateHdrStep(step);
}

// ===== ヘッダーの STEP と見出し（Issue #19）=====
// 各ステップの「Step 04 / 08」と見出しをヘッダーの真ん中に写す（下にスクロールしても何を測っているか分かるように）。
// 写せた時だけ .hdr-step-on を付け、ステップ内の同じ表示を隠す（JS が動かない時は今までどおりステップ内に出る）
function updateHdrStep(step) {
  const box = document.getElementById('hdr-step');
  if (!box) return;
  const card = document.getElementById('step-' + step);
  const num = card && card.querySelector('.step-num');
  const title = card && card.querySelector('.step-title');
  box.querySelector('.hdr-step-num').textContent = num ? num.textContent : '';
  box.querySelector('.hdr-step-title').textContent = title ? title.textContent : '';
  box.classList.toggle('is-empty', !title);
  (box.closest('.shoelace-meter-modal') || document.body).classList.toggle('hdr-step-on', !!title);
}

// ===== STEP 0 PREP CHECKLIST =====
function updatePrepLock() {
  const c1 = document.getElementById('prep-1');
  const c2 = document.getElementById('prep-2');
  const btn = document.getElementById('btn-next');
  if (!c1 || !c2 || !btn) return;
  if (c1.checked && c2.checked) {
    btn.classList.remove('prep-locked');
  } else {
    btn.classList.add('prep-locked');
  }
}
document.getElementById('prep-1').addEventListener('change', updatePrepLock);
document.getElementById('prep-2').addEventListener('change', updatePrepLock);

// ===== NAV UPDATE =====
function updateNav(step) {
  const back = document.getElementById('btn-back');
  const next = document.getElementById('btn-next');
  if (step === 0) {
    back.classList.add('hidden');
    next.textContent = '採寸を始める →';
    updatePrepLock();
  } else if (step === TOTAL_STEPS - 1) {
    back.classList.remove('hidden');
    back.textContent = '← 戻る';
    next.textContent = '最初からやり直す';
  } else {
    back.classList.remove('hidden');
    back.textContent = '← 戻る';
    next.textContent = step === TOTAL_STEPS - 2 ? '結果を見る →' : '次へ →';
  }
}

// ===== GA4（Issue #19）=====
// 1 回の採寸（採寸を始める〜）ごとに、同じステップ・同じ結果を二重に数えない
let meterSession = { reached: {}, results: {} };
function meterSurface() {
  const modal = document.getElementById('shoelace-meter-modal');
  return (modal && modal.classList.contains('is-open')) ? 'modal' : 'page';
}
function meterTrack(name, params) {
  try {
    if (typeof gtag !== 'function') return;
    const p = params || {};
    p.surface = meterSurface();
    // 確認作業は URL に ?debug_mode=1 を付けて行う（GA4 のデータフィルタ「Developer traffic」で集計から外れる）
    if (/[?&]debug_mode=1(&|$)/.test(location.search)) p.debug_mode = true;
    gtag('event', name, p);
  } catch (e) { /* 計測の失敗でメーターを止めない */ }
}
function meterTrackStep(prev, next, direction) {
  if (direction !== 'forward') return;
  if (prev === 0 && next === 1) {
    meterSession = { reached: {}, results: {} };
    meterTrack('meter_start');
  }
  if (!meterSession.reached[next]) {
    meterSession.reached[next] = true;
    meterTrack('meter_step', { step: next });
  }
  if (next === 8) {
    const text = document.getElementById('result-total').textContent.trim();
    const value = parseInt(text, 10);
    if (isNaN(value)) return;
    // 入力値は数値に直してから並べる（2.5 と 2.50 を同じ入力として扱う）
    const key = ['N','W1','WN','Z','m-slider','Wm','rL','rR'].map(function(id) {
      return String(parseFloat(document.getElementById(id).value));
    }).join('|') + '|' + currentPattern;
    if (meterSession.results[key]) return;
    meterSession.results[key] = true;
    meterTrack('meter_result', { value: value });
  }
}

// ===== STEP TRANSITION =====
function goToStep(next, direction) {
  if (next === currentStep || isAnimating) return;
  isAnimating = true;
  const prevStep = currentStep;
  const prevEl = document.getElementById('step-' + currentStep);
  const nextEl = document.getElementById('step-' + next);

  // Place next card off-screen (no transition)
  nextEl.style.transition = 'none';
  nextEl.classList.remove('active', 'slide-left', 'slide-right');
  nextEl.classList.add(direction === 'forward' ? 'slide-right' : 'slide-left');
  nextEl.offsetHeight; // force reflow
  nextEl.style.transition = '';

  requestAnimationFrame(function() {
    prevEl.classList.remove('active');
    prevEl.classList.add(direction === 'forward' ? 'slide-left' : 'slide-right');
    nextEl.classList.remove('slide-left', 'slide-right');
    nextEl.classList.add('active');
  });

  setTimeout(function() {
    prevEl.classList.remove('slide-left', 'slide-right');
    isAnimating = false;
  }, 340);

  currentStep = next;
  updateDots(next);
  updateNav(next);

  meterHoldStop();
  if (prevStep === 8) { resetResultAnim(); meterFeedbackCall('leave'); }
  if (next === 0) meterFeedbackCall('resetRuler');
  if (next > 0) tryRecalcPreview();

  if (next === 1) renderStep1Guide();
  if (next === 2) { syncPatternButtons(currentPattern); renderStep2Art(); }
  if (next === 3) renderStep3Guide();
  if (next === 4) renderStep4Guide();
  if (next === 5) renderStep5Guide();
  if (next === 6) renderStep6Guide();
  if (next === 7) renderStep7Guide();
  if (next === 8) { recalc(); buildStep8Summary(); meterFeedbackCall('enter'); }
  meterTrackStep(prevStep, next, direction);
}

function goNext() {
  if (currentStep === TOTAL_STEPS - 1) { goToStep(0, 'back'); return; }
  if (currentStep === 0) {
    const c1 = document.getElementById('prep-1');
    const c2 = document.getElementById('prep-2');
    if (!c1.checked || !c2.checked) return;
  }
  if (!validateStep(currentStep)) return;
  goToStep(currentStep + 1, 'forward');
}

function goBack() {
  if (currentStep === 0) return;
  goToStep(currentStep - 1, 'back');
}

// ===== VALIDATION =====
function validateStep(step) {
  for (let n = 1; n <= 7; n++) {
    const el = document.getElementById('err-' + n);
    if (el) el.classList.remove('show');
  }
  function showErr(n) { document.getElementById('err-' + n).classList.add('show'); }

  if (step === 1) {
    const N = parseInt(document.getElementById('N').value, 10);
    if (isNaN(N) || N < 2 || N > 12) { showErr(1); return false; }
    const sl = document.getElementById('m-slider');
    sl.max = N;
    if (parseInt(sl.value, 10) > N) sl.value = Math.max(1, Math.ceil(N / 2));
    document.getElementById('m-val').textContent = sl.value;
  }
  // step 2 (通し方選択) はバリデーション不要
  if (step === 3) {
    const v = parseFloat(document.getElementById('Z').value);
    if (isNaN(v) || v <= 0) { showErr(3); return false; }
  }
  if (step === 4) {
    const v = parseFloat(document.getElementById('W1').value);
    if (isNaN(v) || v <= 0) { showErr(4); return false; }
  }
  if (step === 5) {
    const v = parseFloat(document.getElementById('WN').value);
    if (isNaN(v) || v <= 0) { showErr(5); return false; }
  }
  if (step === 6) {
    const v = parseFloat(document.getElementById('Wm').value);
    if (isNaN(v) || v <= 0) { showErr(6); return false; }
  }
  if (step === 7) {
    const rL = parseFloat(document.getElementById('rL').value);
    const rR = parseFloat(document.getElementById('rR').value);
    if (isNaN(rL) || rL < 0 || isNaN(rR) || rR < 0) { showErr(7); return false; }
  }
  return true;
}

// ===== 穴の数の正規化（入力・ガイド図・結果図で共通。入力は 2〜12 対まで）=====
function normalizeN(v) {
  var n = parseInt(v, 10);
  if (isNaN(n) || n === 0) n = 6;
  return Math.min(Math.max(n, 2), 12);
}
function normalizeM(v, N) {
  var m = parseInt(v, 10);
  if (isNaN(m) || m === 0) m = 3;
  return Math.min(Math.max(m, 1), N);
}
function getN() {
  return normalizeN(document.getElementById('N').value);
}

// ===== 紐の図（描画は shoelace-lace-art.js。Issue meta#28）=====
// 図の描画に失敗しても計算・入力確認・計測は止めない（代替表示を出して console に残す）
function _drawLaceArt(containerId, altText, draw) {
  var box = typeof containerId === 'string' ? document.getElementById(containerId) : containerId;
  if (!box) return;
  try {
    if (!window.ShoelaceLaceArt) throw new Error('shoelace-lace-art.js が読み込まれていない');
    draw(window.ShoelaceLaceArt, box);
  } catch (e) {
    console.error('[shoelace-meter] 図を表示できませんでした', containerId, e);
    try {
      if (altText === null) { box.replaceChildren(); return; }
      var p = document.createElement('p');
      p.className = 'lace-art-fallback';
      p.textContent = '図を表示できませんでした' + (altText ? '（' + altText + '）' : '');
      box.replaceChildren(p);
    } catch (e2) {}
  }
}
var _PATTERN_JA = { overlap: 'オーバーラップ', single: 'シングル', parallel: 'パラレル' };

function _renderGuide(step) {
  var N = getN();
  var m = normalizeM(document.getElementById('m-slider').value, N);
  _drawLaceArt('guide' + step + '-wrap', _PATTERN_JA[currentPattern], function(A, box) {
    A.guide(box, { step: step, N: N, m: m, pattern: currentPattern });
  });
}

// ===== STEP 1 GUIDE（穴の数）=====
function renderStep1Guide() { _renderGuide(1); }

// ===== STEP 2 通し方ボタンの図 =====
function renderStep2Art() {
  document.querySelectorAll('#pattern-group [data-lace-art-pattern]').forEach(function(box) {
    // ボタンの文字（オーバーラップ等）で選べるので、失敗時は図を空にするだけ
    _drawLaceArt(box, null, function(A) { A.patternIcon(box, box.getAttribute('data-lace-art-pattern')); });
  });
}

// ===== STEP 3 GUIDE（Z 上下間隔）=====
function renderStep3Guide() { _renderGuide(3); }

// ===== STEP 4 GUIDE（W1 つま先側の横幅）=====
function renderStep4Guide() { _renderGuide(4); }

// ===== STEP 5 GUIDE（WN かかと側の横幅）=====
function renderStep5Guide() { _renderGuide(5); }

// ===== STEP 6 GUIDE（中間の穴 m と横幅 Wm）=====
function renderStep6Guide() { _renderGuide(6); }

// ===== STEP 7 GUIDE（ひもの余り）=====
function renderStep7Guide() {
  _drawLaceArt('guide7-wrap', _PATTERN_JA[currentPattern], function(A, box) {
    A.remainder(box, { pattern: currentPattern });
  });
}

// 表示中のステップの図と Step 2 の図を描き直す（紐の形・色が変わった時に呼ぶ）
function renderLaceArtForCurrentStep() {
  renderStep2Art();
  if (currentStep === 1) renderStep1Guide();
  if (currentStep === 3) renderStep3Guide();
  if (currentStep === 4) renderStep4Guide();
  if (currentStep === 5) renderStep5Guide();
  if (currentStep === 6) renderStep6Guide();
  if (currentStep === 7) renderStep7Guide();
  if (currentStep === 8) recalc();
}

// ===== PREVIEW =====
function tryRecalcPreview() {
  try {
    const N  = parseInt(document.getElementById('N').value, 10);
    const W1 = parseFloat(document.getElementById('W1').value);
    const WN = parseFloat(document.getElementById('WN').value);
    const Z  = parseFloat(document.getElementById('Z').value);
    const m  = parseInt(document.getElementById('m-slider').value, 10);
    const Wm = parseFloat(document.getElementById('Wm').value);
    const rL = parseFloat(document.getElementById('rL').value);
    const rR = parseFloat(document.getElementById('rR').value);
    if (isNaN(N)||N<2||N>12||isNaN(W1)||W1<=0||isNaN(WN)||WN<=0||isNaN(Z)||Z<=0||
        isNaN(m)||m<1||m>N||isNaN(Wm)||Wm<=0||isNaN(rL)||rL<0||isNaN(rR)||rR<0) return;
    const R = rL + rR;
    const s = Z / (N - 1);
    const { W } = calcWidths(N, W1, WN, m, Wm);
    const seg = calcSegments(W, N, s, Z);
    let total;
    if (currentPattern === 'overlap') total = calcOverlap(W, seg, R);
    else if (currentPattern === 'single') total = calcSingle(W, seg, R);
    else total = calcParallel(W, seg, N, R);
    if (!isFinite(total) || isNaN(total)) return;
  } catch(e) {}
}

// ===== CALC LOGIC =====
function calcWidths(N, W1, WN, m, Wm) {
  const W = new Array(N + 1);
  const isFallback = (m === 1 || m === N);
  for (let i = 1; i <= N; i++) {
    if (isFallback || N === 1) {
      W[i] = W1 + ((i - 1) / (N - 1)) * (WN - W1);
    } else if (i <= m) {
      W[i] = W1 + ((i - 1) / (m - 1)) * (Wm - W1);
    } else {
      W[i] = Wm + ((i - m) / (N - m)) * (WN - Wm);
    }
  }
  return { W: W, isFallback: isFallback };
}

function calcSegments(W, N, s, Z) {
  const L1 = new Array(N), L2 = new Array(N);
  for (let i = 1; i <= N - 1; i++) {
    const h = (W[i] + W[i + 1]) / 2;
    L1[i] = Math.sqrt(h * h + s * s);
  }
  for (let i = 1; i <= N - 2; i++) {
    const h = (W[i] + W[i + 2]) / 2;
    L2[i] = Math.sqrt(h * h + (2 * s) * (2 * s));
  }
  let D1 = 0; for (let i = 1; i <= N - 1; i++) D1 += L1[i];
  let D2 = 0; for (let i = 1; i <= N - 2; i++) D2 += L2[i];
  const hY = (W[1] + W[N]) / 2;
  const Y  = Math.sqrt(hY * hY + Z * Z);
  let H = 0; for (let i = 1; i <= N - 1; i++) H += W[i];
  return { L1: L1, L2: L2, D1: D1, D2: D2, Y: Y, H: H };
}

function calcOverlap(W, seg, R)     { return W[1] + 2 * seg.D1 + R; }
function calcSingle(W, seg, R)      { return seg.H + seg.D1 + seg.Y + R; }
function calcParallel(W, seg, N, R) { return seg.H + seg.D2 + (seg.L1[1] || 0) + (seg.L1[N - 1] || 0) + R; }

function recalc(opts) {
  const N  = parseInt(document.getElementById('N').value, 10);
  const W1 = parseFloat(document.getElementById('W1').value);
  const WN = parseFloat(document.getElementById('WN').value);
  const Z  = parseFloat(document.getElementById('Z').value);
  const m  = parseInt(document.getElementById('m-slider').value, 10);
  const Wm = parseFloat(document.getElementById('Wm').value);
  const rL = parseFloat(document.getElementById('rL').value);
  const rR = parseFloat(document.getElementById('rR').value);
  const errEl = document.getElementById('global-error');

  if (isNaN(N)||N<2||N>12||isNaN(W1)||W1<=0||isNaN(WN)||WN<=0||isNaN(Z)||Z<=0||
      isNaN(m)||m<1||m>N||isNaN(Wm)||Wm<=0||isNaN(rL)||rL<0||isNaN(rR)||rR<0) {
    errEl.classList.add('show');
    document.getElementById('result-total').textContent = '\u2014';
    resetResultAnim();
    setResultMini('\u2014');
    return;
  }
  errEl.classList.remove('show');

  const R = rL + rR;
  const s = Z / (N - 1);
  const res = calcWidths(N, W1, WN, m, Wm);
  const W = res.W;
  document.getElementById('fallback-note').classList.toggle('show', res.isFallback);
  const seg = calcSegments(W, N, s, Z);

  let total;
  if (currentPattern === 'overlap') total = calcOverlap(W, seg, R);
  else if (currentPattern === 'single') total = calcSingle(W, seg, R);
  else total = calcParallel(W, seg, N, R);

  if (!isFinite(total) || isNaN(total)) {
    errEl.classList.add('show');
    document.getElementById('result-total').textContent = '\u2014';
    resetResultAnim();
    setResultMini('\u2014');
    return;
  }

  const rounded = Math.ceil(total);
  const el = document.getElementById('result-total');
  const prevShown = parseInt(el.textContent, 10);
  // #result-total は常に確定値（GA4 meter_result・コピー・X 共有がここを読む）。数字が動く見た目は別要素で出す
  el.textContent = String(rounded);
  const animate = !!(opts && opts.animate) && !isNaN(prevShown);
  if (animate && prevShown !== rounded) {
    showResultChange(prevShown, rounded);
  } else if (animate) {
    // 入力は変わったが切り上げた合計は同じ（24.5→25 など）。走っている動き・増減の表示・累計はそのまま
    var countingNow = document.querySelector('#step-8 .result-number-wrap.is-counting');
    if (!countingNow) setResultMini(rounded);
    if (_resultAnim.base !== null) armResultDeltaTimer(_resultAnim.token);   // 増減の表示中なら、最新の入力から 1.5 秒に延ばす
  } else {
    resetResultAnim();
    setResultMini(rounded);
    el.style.animation = 'none';
    requestAnimationFrame(function() { el.style.animation = 'ink-dry 0.7s ease forwards'; });
  }
  updateBreakdown(currentPattern, W, N, seg, R);
  renderDiagram(currentPattern, W, N, s, Z, m, res.isFallback);
  updateShareLink();
}

function updateShareLink() {
  // X の共有ボタンは単独ページにだけある。モーダルには無いので何もしない
  // （無いまま .href に書くと TypeError で goToStep の続き＝入力確認欄と GA4 meter_result が止まる。Issue meta#28）
  var btn = document.getElementById('x-share-btn');
  if (!btn) return;
  var value = document.getElementById('result-total').textContent.trim();
  if (!value || value === '\u2014') return;
  var text = '靴ひもの長さ、ひもを外さずに計算できた🧵\n必要な長さ：' + value + 'cm\n「モンドのくつひもメーター」で調べられます → ' + (window.location.origin + window.location.pathname) + '\n#モンドのくつひもメーター #MONDSHOELACE';
  var url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text);
  btn.href = url;
}

function updateBreakdown(pattern, W, N, seg, R) {
  const rows = [];
  if (pattern === 'overlap') {
    rows.push(['最上段の横バー', W[1].toFixed(2) + ' cm']);
    rows.push(['1段ズレ斜め合計 \u00d7 2', (2 * seg.D1).toFixed(2) + ' cm']);
    rows.push(['余り（左＋右）', R.toFixed(2) + ' cm']);
  } else if (pattern === 'single') {
    rows.push(['横バー合計（' + (N - 1) + '本）', seg.H.toFixed(2) + ' cm']);
    rows.push(['1段ズレ斜め合計', seg.D1.toFixed(2) + ' cm']);
    rows.push(['長い対角', seg.Y.toFixed(2) + ' cm']);
    rows.push(['余り（左＋右）', R.toFixed(2) + ' cm']);
  } else {
    rows.push(['横バー合計（' + (N - 1) + '本）', seg.H.toFixed(2) + ' cm']);
    rows.push(['2段ズレ斜め合計', seg.D2.toFixed(2) + ' cm']);
    rows.push(['端の1段ズレ（上）', (seg.L1[1] || 0).toFixed(2) + ' cm']);
    rows.push(['端の1段ズレ（下）', (seg.L1[N - 1] || 0).toFixed(2) + ' cm']);
    rows.push(['余り（左＋右）', R.toFixed(2) + ' cm']);
  }
  const tb = document.getElementById('breakdown-table');
  tb.replaceChildren();
  rows.forEach(function(pair) {
    const tr = document.createElement('tr');
    const td1 = document.createElement('td'); td1.textContent = pair[0];
    const td2 = document.createElement('td'); td2.className = 'bd-val'; td2.textContent = pair[1];
    tr.appendChild(td1); tr.appendChild(td2); tb.appendChild(tr);
  });
}

function toggleBreakdown() {
  breakdownOpen = !breakdownOpen;
  document.getElementById('breakdown-body').classList.toggle('show', breakdownOpen);
  document.getElementById('breakdown-toggle').classList.toggle('open', breakdownOpen);
  document.getElementById('breakdown-label').textContent = breakdownOpen ? '計算内訳を隠す' : '計算内訳を表示';
}

// ===== COPY =====
function copyResult() {
  var val = document.getElementById('result-total').textContent;
  if (!val || val === '\u2014') return;
  var text = val;
  var showFeedback = function() {
    var fb = document.getElementById('copy-feedback');
    fb.classList.add('show');
    setTimeout(function() { fb.classList.remove('show'); }, 2000);
  };
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(showFeedback).catch(function() {
      fallbackCopy(text); showFeedback();
    });
  } else {
    fallbackCopy(text); showFeedback();
  }

  // GA4 カスタムイベント：モーダルが開いている場合は modal、それ以外は page として計測
  if (typeof gtag === 'function') {
    var modal = document.getElementById('shoelace-meter-modal');
    var isModal = modal && modal.classList.contains('is-open');
    gtag('event', 'copy_result', {
      event_category: 'shoelace_meter',
      event_label: isModal ? 'modal_copy_button' : 'page_copy_button',
      value: parseInt(text) || 0
    });
  }
}
function fallbackCopy(text) {
  var ta = document.createElement('textarea');
  ta.value = text;
  ta.style.cssText = 'position:fixed;top:-999px;left:-999px;opacity:0';
  document.body.appendChild(ta);
  ta.focus(); ta.select();
  try { document.execCommand('copy'); } catch(e) {}
  document.body.removeChild(ta);
}

// ===== PATTERN =====
function syncPatternButtons(value) {
  document.querySelectorAll('.pattern-btn').forEach(function(b) {
    b.classList.toggle('active', b.dataset.value === value);
  });
}
document.getElementById('pattern-group').addEventListener('click', function(e) {
  const btn = e.target.closest('.pattern-btn');
  if (!btn) return;
  currentPattern = btn.dataset.value;
  syncPatternButtons(currentPattern);
  tryRecalcPreview();
  if (currentStep === 8) recalc();
});
document.getElementById('pattern-group-s8').addEventListener('click', function(e) {
  const btn = e.target.closest('.pattern-btn');
  if (!btn) return;
  currentPattern = btn.dataset.value;
  syncPatternButtons(currentPattern);
  recalc({ animate: true });
});

// ===== SLIDER =====
document.getElementById('m-slider').addEventListener('input', function() {
  document.getElementById('m-val').textContent = this.value;
  renderStep6Guide();
  tryRecalcPreview();
});

// ===== INPUT EVENTS =====
['N','W1','WN','Z','Wm','rL','rR'].forEach(function(id) {
  document.getElementById(id).addEventListener('input', tryRecalcPreview);
});
document.getElementById('N').addEventListener('input', renderStep1Guide);

// ===== SVG DIAGRAM（結果図。描画は shoelace-lace-art.js）=====
function renderDiagram(pattern, W, N, s, Z, m, isFallback) {
  _drawLaceArt('svg-container', _PATTERN_JA[pattern], function(A, box) {
    A.result(box, { pattern: pattern, W: W, N: N, m: m, isFallback: isFallback });
  });
}

// ===== STEP 8 EDIT PANEL =====
function buildStep8Summary() {
  var fields = [
    { id: 's8-N',  src: 'N' },
    { id: 's8-Z',  src: 'Z' },
    { id: 's8-W1', src: 'W1' },
    { id: 's8-WN', src: 'WN' },
    { id: 's8-m',  src: 'm-slider' },
    { id: 's8-Wm', src: 'Wm' },
    { id: 's8-rL', src: 'rL' },
    { id: 's8-rR', src: 'rR' }
  ];
  fields.forEach(function(f) {
    document.getElementById(f.id).value = document.getElementById(f.src).value;
  });
  var N = parseInt(document.getElementById('N').value, 10) || 12;
  document.getElementById('s8-m').max = N;
  syncPatternButtons(currentPattern);
}

function syncFromStep8(srcId, targetId) {
  var srcEl = document.getElementById(srcId);
  var tgtEl = document.getElementById(targetId);
  tgtEl.value = srcEl.value;
  if (targetId === 'm-slider') {
    document.getElementById('m-val').textContent = tgtEl.value;
  }
  if (targetId === 'N') {
    // 中間の穴の位置（スライダー・Step 8 の入力欄・表示）を毎回同じ値にそろえる。
    // スライダーは max を下げた時点で値が勝手に丸められるので、Step 8 の入力欄の値を基準に判定する
    var N = normalizeN(tgtEl.value);
    var sl = document.getElementById('m-slider');
    var s8m = document.getElementById('s8-m');
    var curM = parseInt(s8m.value, 10);
    if (isNaN(curM) || curM < 1 || curM > N) curM = Math.max(1, Math.ceil(N / 2));
    sl.max = N;
    s8m.max = N;
    sl.value = curM;
    s8m.value = curM;
    document.getElementById('m-val').textContent = String(curM);
  }
  recalc({ animate: true });
}

// ===== STEP 8: 合計の帯・増減の表示・入力欄の − ＋（Issue meta#28）=====
// 大きな合計がスクロールで隠れたら、カードの上に合計の帯を出す。入力を変えたら数字を新しい値まで動かし、
// 増えた・減った長さを 1.5 秒だけ出す（続けて変えた時は、出し始めてからの累計）
var _resultAnim = { raf: 0, timer: 0, base: null, token: 0 };
function _reduceMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}
function setResultMini(v) {
  var n = document.getElementById('result-mini-num');
  if (n) n.textContent = String(v);
}
// 動きなしの再計算・入力エラー・Step 8 を離れた時・モーダルを閉じた時は、動きと増減の表示を止めて確定値に戻す
// （token を進めて、走っている途中のコールバックが古い値を書き込まないようにする）
function resetResultAnim() {
  _resultAnim.token++;
  cancelAnimationFrame(_resultAnim.raf);
  clearTimeout(_resultAnim.timer);
  _resultAnim.base = null;
  var wrap = document.querySelector('#step-8 .result-number-wrap');
  if (wrap) wrap.classList.remove('is-counting');
  document.querySelectorAll('#step-8 [data-result-delta]').forEach(function(c) { c.classList.remove('show'); });
}
// 増減の表示を 1.5 秒後に消し、累計の基準を捨てる（token が変わっていたら何もしない）
function armResultDeltaTimer(token) {
  clearTimeout(_resultAnim.timer);
  _resultAnim.timer = setTimeout(function() {
    if (token !== _resultAnim.token) return;
    document.querySelectorAll('#step-8 [data-result-delta]').forEach(function(c) { c.classList.remove('show'); });
    _resultAnim.base = null;
  }, 1500);
}
function showResultChange(from, to) {
  try {
    var wrap = document.querySelector('#step-8 .result-number-wrap');
    var anim = document.getElementById('result-anim');
    var mini = document.getElementById('result-mini-num');
    var token = ++_resultAnim.token;
    if (_resultAnim.base === null) _resultAnim.base = from;
    var acc = to - _resultAnim.base;
    document.querySelectorAll('#step-8 [data-result-delta]').forEach(function(c) {
      c.textContent = acc === 0 ? '±0 cm' : (acc > 0 ? '+' : '\u2212') + Math.abs(acc) + ' cm';
      c.classList.add('show');
    });
    [wrap, document.querySelector('#result-mini .result-mini-val')].forEach(function(x) {
      if (!x) return;
      x.classList.remove('is-changed'); void x.offsetWidth; x.classList.add('is-changed');
    });
    armResultDeltaTimer(token);
    cancelAnimationFrame(_resultAnim.raf);
    if (_reduceMotion() || !wrap || !anim) {
      if (wrap) wrap.classList.remove('is-counting');
      setResultMini(to);
      return;
    }
    // 動いている途中で続けて変えたら、今画面に出ている値から動かす（確定値に一度跳ねない）
    if (wrap.classList.contains('is-counting')) {
      var onScreen = parseInt(anim.textContent, 10);
      if (!isNaN(onScreen)) from = onScreen;
    }
    var t0 = performance.now(), diff = to - from;
    wrap.classList.add('is-counting');
    (function tick(now) {
      if (token !== _resultAnim.token) return;
      var k = Math.min(1, (now - t0) / 450), e = 1 - Math.pow(1 - k, 3);
      var v = Math.round(from + diff * e);
      anim.textContent = String(v);
      if (mini) mini.textContent = String(v);
      if (k < 1) { _resultAnim.raf = requestAnimationFrame(tick); }
      else { wrap.classList.remove('is-counting'); setResultMini(to); }
    })(t0);
  } catch (e) { setResultMini(to); }
}
// 入力欄の − ＋（各ステップの数値入力と Step 8 の入力欄で共通。input イベントを送り、
// 既存の処理＝各ステップは tryRecalcPreview・穴の図の描き直し、Step 8 は syncFromStep8 に任せる）
// 1 回押すと 1 刻み、押し続けると連続で変わり、だんだん速くなる（約 1 秒で 10 刻み＝1cm）
function meterStepOnce(b) {
  var inp = b && b.parentNode && b.parentNode.querySelector('input[type="number"]');
  if (!inp) return false;
  var dir = parseInt(b.getAttribute('data-s8-step'), 10);
  var original = inp.value;
  if (inp.value === '' || isNaN(parseFloat(inp.value))) inp.value = inp.min || '0';
  try { if (dir > 0) inp.stepUp(); else inp.stepDown(); } catch (err) { /* 下限・上限で変わらない時もある */ }
  // 小数の桁をそろえる（5.9 の次を「6」ではなく「6.0」と表示）
  var dec = (String(inp.step).split('.')[1] || '').length;
  var nv = parseFloat(inp.value);
  if (!isNaN(nv)) inp.value = nv.toFixed(dec);
  if (inp.value === original) return false;
  var ev = new Event('input', { bubbles: true });
  ev.meterStepper = true;   // お客様の操作の印（スマホ定規が「手で変えた」と判断して測った値の表示を外すため）
  inp.dispatchEvent(ev);
  return true;
}
var _meterHold = { timer: 0, btn: null, n: 0, touch: false, repeated: false, pid: null };
function meterHoldStop() {
  clearTimeout(_meterHold.timer);
  _meterHold.btn = null;
  _meterHold.pid = null;
}
// そのボタンが今操作してよい状態か（表示中の Step にある・モーダルが開いていて閉じる途中でもない・スマホ定規が開いていない）
function meterHoldAllowed(b) {
  var modal = document.getElementById('shoelace-meter-modal');
  return !!(b && b.isConnected && b.closest('.step-card.active') &&
    !(modal && modal.contains(b) && (!modal.classList.contains('is-open') || modal.classList.contains('is-closing'))) &&
    !(window.LaceRuler && window.LaceRuler.isOpen()));
}
function meterInside(b, e) {
  var r = b.getBoundingClientRect(), pad = 8;   // 指の小さなずれは許す
  return e.clientX >= r.left - pad && e.clientX <= r.right + pad && e.clientY >= r.top - pad && e.clientY <= r.bottom + pad;
}
function meterHoldRepeat(b) {
  if (_meterHold.btn !== b) return;
  if (!meterHoldAllowed(b)) { meterHoldStop(); return; }   // 途中で Step 移動・モーダル終了・定規起動があったら止める
  _meterHold.repeated = true;
  if (!meterStepOnce(b)) { meterHoldStop(); return; }   // 上限・下限に着いたら止める
  _meterHold.n++;
  _meterHold.timer = setTimeout(function() { meterHoldRepeat(b); }, Math.max(50, 150 * Math.pow(0.9, _meterHold.n)));
}
// マウスは押した瞬間に 1 刻み。指（タッチ）は離した時に 1 刻み（スクロールしようとして触れただけでは変えない）。
// 操作は 1 本の指（1 つのポインター）だけ。操作中のほかの指は無視する
document.addEventListener('pointerdown', function(e) {
  var b = e.target.closest ? e.target.closest('[data-s8-step]') : null;
  if (!b || (e.pointerType === 'mouse' && e.button !== 0)) return;
  if (_meterHold.btn) return;
  if (!meterHoldAllowed(b)) return;
  _meterHold.btn = b; _meterHold.pid = e.pointerId; _meterHold.n = 0; _meterHold.repeated = false;
  _meterHold.touch = e.pointerType !== 'mouse';
  if (!_meterHold.touch && !meterStepOnce(b)) { meterHoldStop(); return; }
  _meterHold.timer = setTimeout(function() { meterHoldRepeat(b); }, 400);
});
document.addEventListener('pointermove', function(e) {
  if (!_meterHold.btn || e.pointerId !== _meterHold.pid) return;
  if (!meterInside(_meterHold.btn, e)) meterHoldStop();   // ボタンの外へずれたら連続も 1 刻みも取り消す
}, true);
document.addEventListener('pointerup', function(e) {
  var b = _meterHold.btn;
  if (!b || e.pointerId !== _meterHold.pid) return;
  if (_meterHold.touch && !_meterHold.repeated && meterInside(b, e) && meterHoldAllowed(b)) meterStepOnce(b);
  meterHoldStop();
}, true);
document.addEventListener('pointercancel', function(e) {
  if (_meterHold.btn && e.pointerId === _meterHold.pid) meterHoldStop();
}, true);
window.addEventListener('blur', meterHoldStop);
document.addEventListener('visibilitychange', function() { if (document.hidden) meterHoldStop(); });
// キーボード（Enter・スペース）での操作は click で 1 刻み。マウス・指の click は pointerdown/up で処理済みなので無視する
document.addEventListener('click', function(e) {
  var b = e.target.closest ? e.target.closest('[data-s8-step]') : null;
  if (!b || e.detail !== 0 || !meterHoldAllowed(b)) return;
  meterStepOnce(b);
});
document.addEventListener('contextmenu', function(e) {
  if (e.target.closest && e.target.closest('[data-s8-step]')) e.preventDefault();   // 長押しでメニューを出さない
});
(function() {
  var card = document.getElementById('step-8');
  var mini = document.getElementById('result-mini');
  var big = document.getElementById('result-total');
  if (!card || !mini || !big || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(entries) {
    var visible = entries[0].isIntersecting;
    mini.classList.toggle('show', !visible);
  }, { root: card, rootMargin: '-56px 0px 0px 0px', threshold: 0 }).observe(big);
})();

// ===== 結果画面のアンケート（Issue #19・meta plans/2026-10_くつひもメーター_結果画面のアンケート.md）=====
// 👍／👎 は GA4（meter_feedback）、ひと言は Google フォームに裏側で送る（no-cors のため届いたかは画面からは分からない）。
// 部品は snippets/meter-feedback.liquid。ここが失敗しても、メーター本体（遷移・結果・コピー・定規）は止めない
var meterFeedback = (function() {
  try { return meterFeedbackBuild(); } catch (e) { return null; }   // 初期化の失敗で、この後の INIT を止めない
})();
function meterFeedbackBuild() {
  var FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSd7yCyi9mD9QgsA4PjHmOxKRy5bduAFyScnmdOFXjTr-1xxgw/formResponse';
  var ENTRY = {
    rating: 'entry.2079474950', comment: 'entry.292077507', device: 'entry.1278489702',
    surface: 'entry.1412920736', ruler: 'entry.1062357148', length: 'entry.1172139324'
  };
  var KEY = 'mond_meter_feedback_v1';
  var root = document.querySelector('[data-meter-feedback]');
  var answered = false;               // localStorage が使えない時も、このページを開いている間は覚えておく
  var cur = { rating: '', sending: false, thanked: false };
  var rulerUsed = false;              // 今回の採寸（STEP 0 から結果まで）で「この値を入れる」を押したか
  if (!root) return null;             // render を外した時は何もしない

  function $(sel) { return root.querySelector(sel); }
  function isAnswered() {
    if (answered) return true;
    try { if (window.localStorage.getItem(KEY)) answered = true; } catch (e) {}
    return answered;
  }
  function markAnswered() {
    answered = true;
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }
  function device() {
    var ua = navigator.userAgent || '';
    if (/iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return 'iPad';
    if (/iPhone|iPod/.test(ua)) return 'iPhone';
    if (/Android/.test(ua)) return 'Android';
    if (/Windows/.test(ua)) return 'Windows';
    if (/Macintosh/.test(ua)) return 'Mac';
    return 'other';
  }
  function resultLength() {               // 「送る」を押した時点の合計。数字でない時（— など）は空欄
    var el = document.getElementById('result-total');
    var v = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(v) ? '' : String(v);
  }
  function updateCount() {
    var t = $('[data-mfb-text]'), c = $('[data-mfb-count]');
    if (t && c) c.textContent = t.value.length + ' / 200';
  }
  function clearInput() {                 // 入力中の状態だけ消す（回答済みの記録は残す）
    cur.rating = ''; cur.sending = false; cur.thanked = false;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mfb-rate]'), function(b) {
      b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false');
    });
    var t = $('[data-mfb-text]'); if (t) t.value = '';
    var s = $('[data-mfb-send]'); if (s) s.disabled = false;
    $('[data-mfb-form]').hidden = true;
    $('[data-mfb-ask]').hidden = false;
    $('[data-mfb-thanks]').hidden = true;
    updateCount();
  }
  function enter() {                      // 結果画面に入るたび・ポップアップを開いた時
    clearInput();
    // 出すのは結果画面（STEP 8）にいて未回答の時だけ。隠れた STEP の中でも Tab で届くので、それ以外は必ず hidden
    root.hidden = isAnswered() || currentStep !== 8;
  }
  function leave() {                      // 結果画面から出る時・ポップアップを閉じ始めた時。書きかけは捨てる
    clearInput();
    root.hidden = true;
  }
  function rate(r) {
    if (cur.sending || cur.thanked || cur.rating === r) return;   // 同じ方の押し直しは送らない
    var changed = !!cur.rating;
    if (!changed) markAnswered();         // 最初に押した時点で回答済み（ひと言を書かずに離れても、次からは出さない）
    cur.rating = r;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mfb-rate]'), function(b) {
      var on = b.getAttribute('data-mfb-rate') === r;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $('[data-mfb-label]').textContent = r === 'down'
      ? 'どこで困りましたか？（任意）' : 'よければ、ひと言お聞かせください（任意）';
    $('[data-mfb-form]').hidden = false;
    meterTrack('meter_feedback', {
      rating: r, changed: changed ? 'true' : 'false', ruler_used: rulerUsed ? 'true' : 'false'
    });
  }
  function post(text) {
    try {
      var body = new URLSearchParams();
      body.append(ENTRY.rating, cur.rating);
      body.append(ENTRY.comment, text);
      body.append(ENTRY.device, device());
      body.append(ENTRY.surface, meterSurface());
      body.append(ENTRY.ruler, rulerUsed ? 'used' : 'not_used');
      body.append(ENTRY.length, resultLength());
      var p = fetch(FORM_URL, { method: 'POST', mode: 'no-cors', keepalive: true, body: body });
      if (p && typeof p.catch === 'function') p.catch(function() {});
    } catch (e) { /* 送れなくても画面は止めない */ }
  }
  function send() {
    if (cur.sending || cur.thanked || !cur.rating) return;
    cur.sending = true;
    var btn = $('[data-mfb-send]'); if (btn) btn.disabled = true;
    var t = $('[data-mfb-text]');
    var text = t ? t.value.replace(/^\s+|\s+$/g, '') : '';
    if (text) {
      post(text.slice(0, 200));
      meterTrack('meter_feedback_comment', { rating: cur.rating, length: text.length });
    }
    cur.thanked = true;
    $('[data-mfb-ask]').hidden = true;
    var thanks = $('[data-mfb-thanks]');
    thanks.hidden = false;
    try { thanks.focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function(e) {
    try {
      var b = e.target.closest && e.target.closest('[data-mfb-rate]');
      if (b) { rate(b.getAttribute('data-mfb-rate')); return; }
      if (e.target.closest && e.target.closest('[data-mfb-send]')) send();
    } catch (err) {}
  });
  var ta = $('[data-mfb-text]');
  if (ta) ta.addEventListener('input', updateCount);

  return {
    enter: enter,
    leave: leave,
    onOpen: function() { rulerUsed = false; enter(); },   // ポップアップを開いた時（goToStep(0) がガードで省かれても状態を戻す）
    resetRuler: function() { rulerUsed = false; },
    markRuler: function() { rulerUsed = true; }
  };
}
// 遷移・開閉から呼ぶ入口。アンケートが無い・壊れていても、呼び出し元には何も伝えない
function meterFeedbackCall(name) {
  try { if (meterFeedback && typeof meterFeedback[name] === 'function') meterFeedback[name](); } catch (e) {}
}

// ===== INIT =====
updateNav(0);
renderStep1Guide();
renderStep2Art();
renderStep3Guide();
renderStep4Guide();
renderStep5Guide();
renderStep6Guide();
renderStep7Guide();
